














import Vue from 'vue';
import NumericTextField from './NumericTextField.vue';
import { VarNum } from '../model';
import { InputMode } from '../model';

export default Vue.extend({
  components: {
    NumericTextField,
  },

  props: {
    value: {
      type: VarNum,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: false,
    },
    prefix: {
      type: String,
      required: false,
    },
    suffix: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      modes: [
        { mode: InputMode.Constant, text: 'Constant' },
        { mode: InputMode.StepRamp, text: 'Ramped' },
      ],
      localVal: this.value,
    };
  },

  methods: {
    shouldShowRamp(): boolean {
      return this.value.mode === InputMode.StepRamp;
    },
  },

  computed: {
  },

  watch: {
    localVal: {
      handler(val: VarNum, old: VarNum) {
        this.$emit('input', this.localVal);
      },
      deep: true,
    },
  },
});
